import { addRxPlugin, createRxDatabase } from 'rxdb/plugins/core';
import { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';
import { RxDBLeaderElectionPlugin } from 'rxdb/plugins/leader-election';
import {
	profileSchema,
	allEndUserSchema,
	leadUserSchema,
	endUserCategorySchema,
	dealersSchema,
	productsSchema,
	oneToOneMeetingsListSchema,
	meetingsSchema,
	townSchema,
	clubSchema,
	venueSchema,
	surfacesSchema,
	typeOfConstructionSchema,
	subClassificationSchema,
	projectClassificationSchema,
	stageOfConstructionSchema,
	bdeListSchema,
	prospectiveSiteSchema,
	sourceOfSiteLeadSchema,
	meetingModuleSchema,
	meetingTypeSchema,
	btlObjectiveSchema,
	siteListSchema,
	btlObjectiveProductSchema,
	dashboardBannerSchema,
	dfccClubSchema,
	productMasterSchema,
	dropdownSchema,
	ccTownListSchema,
	drChecklistDraftSchema,
} from '@rxdb/schema';
import { RxDBQueryBuilderPlugin } from 'rxdb/plugins/query-builder';
import { RxDBDevModePlugin } from 'rxdb/plugins/dev-mode';
import { RxDBCleanupPlugin } from 'rxdb/plugins/cleanup';
import { RxDBMigrationPlugin } from 'rxdb/plugins/migration-schema';

addRxPlugin(RxDBMigrationPlugin);
addRxPlugin(RxDBCleanupPlugin);
if (process.env.NODE_ENV !== 'production') {
	addRxPlugin(RxDBDevModePlugin);
}
addRxPlugin(RxDBQueryBuilderPlugin);
addRxPlugin(RxDBLeaderElectionPlugin);

let dbPromise = null;
let dbInstance = null;
let myDatabase = null;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createDatabase = async () => {
	myDatabase = await createRxDatabase({
		name: 'mpowercc',
		storage: getRxStorageDexie(),
		multiInstance: true,
		eventReduce: true,
		cleanupPolicy: {
			minimumDeletedTime: 1000 * 60 * 60,
			minimumCollectionAge: 1000 * 60 * 60,
			runEach: 5 * 60 * 1000,
		},
	});

	window.db = myDatabase;

	await myDatabase.addCollections({
		profile: profileSchema,
		end_users: allEndUserSchema,
		new_leads: leadUserSchema,
		end_user_categories: endUserCategorySchema,
		dealers: dealersSchema,
		products: productsSchema,
		one_to_one_meetings: oneToOneMeetingsListSchema,
		meetings: meetingsSchema,
		towns: townSchema,
		clubs: clubSchema,
		venues: venueSchema,
		surfaces: surfacesSchema,
		type_of_construction: typeOfConstructionSchema,
		sub_classifications: subClassificationSchema,
		project_classifications: projectClassificationSchema,
		stages_of_construction: stageOfConstructionSchema,
		bde_list: bdeListSchema,
		prospective_sites: prospectiveSiteSchema,
		source_of_site_leads: sourceOfSiteLeadSchema,
		meeting_modules: meetingModuleSchema,
		meeting_types: meetingTypeSchema,
		btl_objectives: btlObjectiveSchema,
		site_list: siteListSchema,
		btl_objective_products: btlObjectiveProductSchema,
		dashboard_banner: dashboardBannerSchema,
		dfcc_clubs: dfccClubSchema,
		product_masters: productMasterSchema,
		dropdowns: dropdownSchema,
		cc_town_list: ccTownListSchema,
		dr_checklist_drafts: drChecklistDraftSchema,
	});

	dbInstance = myDatabase;
	return myDatabase;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getDatabase = () => {
	if (!dbPromise) dbPromise = createDatabase();
	return dbPromise;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const cleanupDatabase = async () => {
	if (dbInstance) {
		dbInstance.broadcastChannel?.close();
		const collections = Object.values(dbInstance.collections);

		// Remove all data from collections
		await Promise.all(
			collections.map(async (collection) => {
				await collection.remove();
			})
		);

		// Destroy the database
		await dbInstance.destroy();

		dbInstance = null;
		dbPromise = null;
	}
};
